import cx from 'classnames';
import type { FC, ReactNode } from 'react';

import Popover from '../Popover';
import type { PopoverPlacement, PopoverTriggerEvent } from '../types';

interface Props {
  body: ReactNode;
  children: ReactNode;
  className?: string;
  footer?: ReactNode;
  offset?: number;
  placement?: PopoverPlacement;
  title?: string;
  trigger?: PopoverTriggerEvent;
  withGradientBorder?: boolean;
}

const InlineDialog: FC<Props> = ({
  body,
  children,
  className,
  footer,
  offset,
  placement = 'bottom-start',
  title,
  trigger = 'click',
  withGradientBorder = true
}) => {
  const renderTooltipContent = (): ReactNode => {
    const classNames: string = cx(
      {
        '[border-image:linear-gradient(88deg,#B97ACD,#FF7582)_30] border border-solid border-transparent': withGradientBorder
      },
      'max-w-sm p-6 text-sm leading-5 text-grey-dark'
    );

    if (!title) {
      return body;
    }

    return (
      <div className={classNames}>
        <h1 className="mb-2 text-lg font-bold">{title}</h1>
        <div>{body}</div>
        {footer && <div className="mt-4">{footer}</div>}
      </div>
    );
  };

  return (
    <Popover
      offset={offset}
      placement={placement}
      popover={renderTooltipContent()}
      showArrow={false}
      trigger={trigger}
      triggerClassName={className}
    >
      {children}
    </Popover>
  );
};

export type { Props as InlineDialogProps };
export default InlineDialog;
